// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3wBSx","question":"Question_question__3KkxG","description":"Question_description__3egas"};